module.exports = __webpack_public_path__ + "static/koupit-36f79de1514f6c6340d07984d6ae1791.svg";